import React from "react";
import { Link } from "react-router-dom";
//import Table from "../components/table/Table";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import axios from "axios";

const NicheDirectories = ({ cat, setCat }) => {
  const [nicheDirectories, setnicheDirectories] = React.useState([]);

  const fetchCatSubCat = async () => {
    const res = await axios.get(
      "https://www.api.webdirectories.info/api/category/get-all"
    );
    setCat(res.data);
  };

  React.useEffect(() => {
    fetchCatSubCat();
  }, []);

  return (
    <div style={{ background: "#f6f6f6" }}>
      <section id="hero" className="d-flex align-items-center">
        <div
          className="container hero-banner text-center"
          data-aos="zoom-out"
          data-aos-delay="100"
        >
          <h3 className="text-white font-weight-bold text-center">
            Niche Directory List
          </h3>
          <div className="mt-3 d-flex align-items-center justify-content-center">
            <h4 className="text-center text-secondary">Home</h4>
            <span style={{ color: "#f38e35" }}>
              <i class="bi bi-caret-right mx-1"></i>
            </span>
            <a className="text-white text-bold">Niche Directory List</a>
          </div>
        </div>
      </section>
      <div className="container">
        <div
          className="d-flex align-items-center justify-content-start px-1 py-1 bg-white my-2"
          style={{ width: "100%" }}
        >
          <h4 className="text-secondary text-center">Home</h4>
          <span style={{ color: "#f38e35" }}>
            <i class="bi bi-caret-right mx-1"></i>
          </span>

          <p className="mt-3">Niche Directory List</p>
        </div>
        <div className="container my-5 bg-white dtable table-directories">
          <div className="mb-5">
            <div className="my-3 py-4">
              <p className="text-center px-3">
                A list of niche Web directories on the internet. If you want
                your niche directory added to this list send a payment of $179
                to webdirectories.info@gmail.com via paypal and it will be
                reviewed.
              </p>
            </div>
            {/* <Table data={nicheDirectories}/> */}
            <ListGroup>
              <div className="row mx-5">
                {cat &&
                  cat.map((item, i) => (
                    <ListGroupItem
                      key={i}
                      variant="flush"
                      className="col-6"
                      as="a"
                    >
                      <Link
                        to={`/sub-niche/${item.parentCat.split(" ").join("-")}`}
                      >
                        {item.parentCat}
                      </Link>
                    </ListGroupItem>
                  ))}
              </div>
            </ListGroup>
            ;
          </div>
        </div>
      </div>
    </div>
  );
};

export default NicheDirectories;
